export function alphanumericalSort(a: string, b: string): number {
  return a.toLowerCase().localeCompare(b.toLowerCase());
}

export function reverseAlphanumericalSort(a: string, b: string): number {
  return -1 * alphanumericalSort(a, b);
}
